import React, { useEffect, useState } from "react";
import Wrapper from "../../../components/Wrapper";
import { labApi } from "../../../services/labApi";

export default function TestCapacityPage() {
  const [capacity, setCapacity] = useState(null);

  useEffect(() => {
    labApi.getTestCapacity().then(setCapacity).catch(console.error);
  }, []);

  return (
    <Wrapper>
      <div className="space-y-6 pb-20 lg:pb-6">
        <h2 className="m-0 text-2xl font-bold text-slate-800">Test Capacity</h2>
        {!capacity ? (
          <div className="bg-white border rounded-xl p-4">Loading capacity...</div>
        ) : (
          <>
            <div className="bg-white border rounded-xl p-4">
              <p className="text-sm text-slate-500 m-0">Overall Capacity</p>
              <p className="text-4xl font-bold m-0">{capacity.overall_capacity}</p>
            </div>
            <div className="bg-white border rounded-xl p-4">
              <h3 className="text-lg font-semibold">Limiting Reagents</h3>
              <div className="flex flex-wrap gap-2">
                {(capacity.limiting_reagents || []).map((name) => (
                  <span key={name} className="px-3 py-1 rounded-full bg-amber-100 text-amber-800 text-sm">{name}</span>
                ))}
              </div>
            </div>
            <div className="bg-white border rounded-xl p-4">
              <h3 className="text-lg font-semibold">Detailed Breakdown</h3>
              <div className="space-y-2">
                {(capacity.detailed_breakdown || []).map((row) => (
                  <div key={row.reagent_id} className="border rounded-lg px-3 py-2">
                    <p className="m-0 font-medium">{row.reagent_name}</p>
                    <p className="m-0 text-sm text-slate-600">
                      {row.preparation_mode === "instant" ? "From chemicals" : "Reagent stock"}: {row.stock}{" "}
                      {row.unit}, Tests supported: {row.tests_supported}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </Wrapper>
  );
}
